<template>
  <div>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-start mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="mr-1 per-page-selector d-inline-block ml-50"
          />
          <b-button v-b-modal.add-serviceSpecifications variant="primary"
            >Add Service Specifications</b-button
          >
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
        >
          <label class="mr-1">
            Search
          </label>
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              class="mr-1 d-inline-block"
              placeholder="Search..."
              v-model="searchWord"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Larger screen than mobile -->
    <div class="d-none d-md-flex">
      <b-table
        class="border"
        no-local-sorting
        @sort-changed="sortingChanged"
        responsive
        striped
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items="serviceSpecifications"
        :fields="serviceSpecificationsFields"
      >
        <template #cell(action)="serviceSpecifications">
          <div class="d-flex justify-content-between">
            <div class="d-flex">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="secondary"
                class="mr-1 btn-icon"
                @click="editModal(serviceSpecifications.item.id, serviceSpecifications.item.name)"
              >
                <feather-icon icon="Edit3Icon" />
              </b-button>
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="danger"
                  class="mr-1 btn-icon"
                  @click="showMsgBoxDelete(serviceSpecifications.item.id)"
                >
                  <feather-icon icon="Trash2Icon" />
                </b-button>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <!-- Mobile screen -->
    <div class="d-flex d-md-none flex-column">
      <!-- Loading -->
      <div v-if="isBusy" class="text-center text-danger my-2">
        <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
        <strong class="text-secondary">Loading...</strong>
      </div>
      <!-- Data -->
      <div v-if="!isBusy && serviceSpecifications.length == 0" class="text-center text-danger my-2">
        <strong class="text-secondary">No data</strong>
      </div>
      <b-row
        v-if="!isBusy && serviceSpecifications.length > 0"
        v-for="(item, index) in serviceSpecifications"
        :key="item.id"
        class="mb-3 list-item"
      >
        <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
          <strong class="flex-grow-1 truncate">{{ item.name }}</strong>
          <div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="mr-1 btn-icon"
              @click="editModal(item.id, item.name)"
            >
              <feather-icon icon="Edit3Icon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="mr-1 btn-icon"
              @click="showMsgBoxDelete(item.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </b-col>
        <b-col cols="12" class="d-flex flex-wrap">
          <div style="font-size: 0.75rem;">
            <p><strong>FORMAT:</strong> {{ item.format || '-' }}</p>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">
            Showing {{ pagination.from }} to {{ pagination.to }} of
            {{ pagination.total }} entries
          </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="pagination.total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            @input="changePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal
      title="Add Service Specifications"
      hide-footer
      id="add-serviceSpecifications"
      centered
      hide-header-close
      no-close-on-backdrop
    >
      <b-form @submit.prevent="addServiceSpecifications">
        <b-form-group label-for="value">
          <template slot="label">
            <span>Name <strong class="text-danger">*</strong></span>
          </template>
          <b-form-input id="title" required v-model="specification_name" />
        </b-form-group>
        <b-form-group label-for="value">
          <template slot="label">
            <span>Format</span>
          </template>
          <vue-tags-input
            v-model="tag"
            :tags="tags"
            @tags-changed="newTags => tags = newTags"
          />
        </b-form-group>
        <b-form-group class="d-flex justify-content-end">
          <b-button
            type="button"
            variant="light"
            class="mr-1"
            @click="$bvModal.hide('add-serviceSpecifications')"
            :disabled="form.isLoading"
          >
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" :disabled="form.isLoading">
            Save
          </b-button>
        </b-form-group>
      </b-form>
    </b-modal>

    <b-modal
      title="Edit Service Specification"
      hide-footer
      id="edit-service-specifications"
      centered
      hide-header-close
      no-close-on-backdrop
      >
      <b-form @submit.prevent="editServiceSpecifications">
        <b-form-group label-for="value">
          <template slot="label">
            <span>Name <strong class="text-danger">*</strong></span>
          </template>
          <b-form-input id="title" required v-model="edit_specifications_name" />
        </b-form-group>
        <b-form-group class="d-flex justify-content-end">
          <b-button
            type="button"
            variant="light"
            class="mr-1"
            @click="$bvModal.hide('edit-service-specifications')"
            :disabled="form.isLoading"
          >
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" :disabled="form.isLoading">
            Save
          </b-button>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import vSelect from 'vue-select'
import VueTagsInput from '@johmun/vue-tags-input';
import {
  BRow,
  BCol,
  BTable,
  BFormCheckbox,
  BButton,
  BSpinner,
  BForm,
  BFormGroup,
  BFormInput,
  BPagination,
  BModal,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { generateToken } from '@/auth/helperAuth'

export default {
  components: {
    VueTagsInput,
    BTable,
    BFormCheckbox,
    BButton,
    BSpinner,
    BRow,
    BCol,
    vSelect,
    BForm,
    BFormGroup,
    BFormInput,
    BPagination,
    BModal,
  },

  directives: {
    Ripple,
    VBModal,
  },

  data() {
    return {
      sortBy: 'start_datetime',
      sortDesc: true,
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      serviceSpecifications: [],
      serviceSpecificationsFields: [
        { key: 'name', label: 'Name' },
        { key: 'format', label: 'Format' },
        { key: 'action', label: 'Action' },
      ],
      searchWord: '',
      specification_name: '',
      edit_specifications_name: '',
      // action: '',
      form: {
        isLoading: false 
      },
      tag: '',
      token: '',
      tags: [],
    }
  },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    };
    this.token = generateToken(payload)
  },

  watch: {
    perPage() {
      this.fetchServiceSpecifications()
    },
    currentPage() {
      this.fetchServiceSpecifications()
    },
    searchWord(newVal) {
      this.searchByTitle()
    },
  },

  mounted() {
    this.fetchServiceSpecifications()
  },

  methods: {

    fetchServiceSpecifications() {
      this.isBusy = true
      
      let params = {
        table: "service_specifications",
        page: this.currentPage,
        perPage: this.perPage,
        order: 'DESC'
      }
      if (this.searchWord) {
        params.search = this.searchWord.toString().trim()
      }
      this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list`, {
        params: params,
        withCredentials: true,
        headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
      })
      .then(({ data }) => {
        this.currentPage = data.current_page
        this.pagination.total = data.total
        this.pagination.from = data.from
        this.pagination.to = data.to
        this.serviceSpecifications = data.data
      })
      .finally(() => {
        this.isBusy = false
      })

      
    },

    searchByTitle: debounce(function() {
      this.fetchServiceSpecifications()
    }, 200),

    changePage(page) {
      this.currentPage = page
    },

    sortingChanged({ sortBy, sortDesc }) {
      ;(this.sortBy = sortBy), (this.sortDesc = sortDesc)
      this.fetchServiceSpecifications()
    },

    addServiceSpecifications() {
      const format = []
      this.tags.forEach((i) => {
        format.push(i.text)
      })
      this.form.isLoading = true

      const request = {
        table: "service_specifications",
        properties: {
          name: this.specification_name,
          format: format
        }
      }

      this.$http
        .post(`${process.env.VUE_APP_API_HELPER_URL}/internal/data`, request, {
          withCredentials: true,
          headers: { 
            'Client-Device': 'browser',
            'Authorization': `${this.token}`,
          },
        })
        .then((response) => {
          // Notifikasi dan reset form jika berhasil
          this.$notif('Success', 'Service Specification successfully added.', 'success');
          this.$bvModal.hide('add-serviceSpecifications');
          this.specification_name = '';
          this.fetchServiceSpecifications();
        })
        .catch((error) => {
          console.error('Error:', error);
          this.$notif('Error', error.response?.data?.message);
        })
        .finally(() => {
          this.form.isLoading = false;
        });
    },

    editModal(id,name){
      this.edit_specifications_name = name;
      this.$bvModal.show('edit-service-specifications')
    },

    editServiceSpecifications() {
      console.log(this.edit_specifications_name)
      
    },

    showMsgBoxDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.deleteSpecifications(id).then(() => {
              this.fetchServiceSpecifications()
            })
          }
        })
    },

    async deleteSpecifications(id) {
      this.isBusy = true
      return await this.$http
        .delete(`${process.env.VUE_APP_API_HELPER_URL}/internal/data?table=service_specifications&id=${id}`)
        .then(res => {
          this.$notif(
            'Success',
            'News has been successfully deleted.',
            'success'
          )
        })
        .catch(({ data }) => {
          this.$notif('Something Error', data.message, 'danger')
        })
        .finally(() => {
          this.isBusy = false
        })
    },

    // deleteSpecifications(id) {
    //   console.log(id)

    //   // return this.$http.delete(`pcc/product/${pccId}`)
    // },
    
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
